/* Dandy — Buy now (cards + PDP): add to cart then go straight to checkout. Hardened + toast (no alert). */
(function () {
  'use strict';
  function routes() { return (window.Dandy && window.Dandy.routes) || {}; }
  function toast(msg) {
    try {
      var n = document.createElement('div');
      n.setAttribute('role', 'status');
      n.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:99999;background:#0B0B0B;color:#F6F2EC;font:600 13px/1.45 Helvetica,Arial,sans-serif;letter-spacing:.02em;padding:12px 18px;border-radius:4px;max-width:88vw;text-align:center;box-shadow:0 8px 30px rgba(0,0,0,.28);';
      n.textContent = msg;
      document.body.appendChild(n);
      setTimeout(function () { n.remove(); }, 3200);
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    try {
      var bn = e.target.closest('[data-buy-now]');
      if (!bn) return;
      e.preventDefault();
      var id = bn.dataset.variantId;
      if (!id) { var form = bn.closest('form'); var inp = form && form.querySelector('[data-variant-id]'); id = inp && inp.value; }
      if (!id) return;
      var label = bn.textContent; bn.disabled = true; bn.textContent = 'PROCESSING…';
      var fd = new FormData(); fd.append('id', id); fd.append('quantity', '1');
      fetch(routes().cart_add_url || '/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) { throw new Error('add failed'); } window.location.href = '/checkout'; })
        .catch(function (err) { console.error(err); bn.disabled = false; bn.textContent = label; toast('Could not start checkout — please try Add to bag.'); });
    } catch (err) { console.error('buy-now.js failed', err); }
  });
})();
